/******/ (() => { // webpackBootstrap
/*!********************************************!*\
  !*** ./zrc/scripts/templates/page-faqs.js ***!
  \********************************************/
class PageFaqs extends window.HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.faqsTabs();
    this.faqsAccordions();
  }
  faqsTabs() {
    var myTabs = this.container.querySelectorAll(".faq-navigation-item");
    function myTabClicks(tabClickEvent) {
      for (var i = 0; i < myTabs.length; i++) {
        myTabs[i].classList.remove("is-active");
      }
      var clickedTab = tabClickEvent.currentTarget;
      clickedTab.classList.add("is-active");
      tabClickEvent.preventDefault();
      var myContentPanes = this.container.querySelectorAll(".faq-navigation-content");
      for (var _i = 0; _i < myContentPanes.length; _i++) {
        myContentPanes[_i].classList.remove("is-active");
      }
      var anchorReference = tabClickEvent.target;
      var activePaneId = anchorReference.getAttribute("href");
      var activePane = this.container.querySelector(activePaneId);
      activePane.classList.add("is-active");
    }
    for (var i = 0; i < myTabs.length; i++) {
      myTabs[i].addEventListener("click", myTabClicks.bind(this));
    }
  }
  faqsAccordions() {
    $(".faq-question").click(function () {
      $(".faq-indicator.is-active").removeClass("is-active");
      $(".faq-indicator").text("+");
      if ($('.faq-answer').is(':visible')) {
        $(".faq-answer").slideUp(300);
      }
      if ($(this).next(".faq-answer").is(':visible')) {
        $(this).next(".faq-answer").slideUp(300);
      } else {
        $(this).next(".faq-answer").slideDown(300);
        $(this).children(".faq-indicator").addClass("is-active");
        $(this).children(".faq-indicator").text("-");
      }
    });
  }
}
if (window.customElements.get('page-faqs') == null) {
  window.customElements.define('page-faqs', PageFaqs);
}
/******/ })()
;